<script>
    import { Tooltip } from 'bootstrap';

    export default {
        name: 'InfoTooltip',
        props: {
            text: String,
            iconClass: { type: String, default: 'bi bi-info-circle text-muted fs-4' }
        },
        data() {
            return { tooltip: null };
        },
        mounted() {
            this.tooltip = new Tooltip(this.$el, { title: this.text, placement: 'top' });
        },
        beforeUnmount() {
            this.tooltip?.dispose();
        },
        watch: {
            text(value) {
                this.tooltip?.setContent({ '.tooltip-inner': value });
            }
        }
    };
</script>

<template>
    <span style="cursor: help" tabindex="0">
        <i :class="iconClass"></i>
    </span>
</template>
